import { useState } from "react";
import { Select, FormLabel, FormControl, InputGroup } from "@chakra-ui/react";
import ReactSelect from "react-select";

import { ReactComponent as ArrowDown } from "../../assets/svgs/ArrowDownSelect.svg";

const CustomSelect = ({
  label,
  defaultValue = "",
  onChange = () => {},
  placeholder,
  labelColor,
  labelSize,
  icon,
  inputStyle,
  style,
  isMultiSelect = false,
  children,
}) => {
  const [value, setValue] = useState(defaultValue);

  const handleChange = (e) => {
    setValue(e.target.value);
    onChange(e.target.value);
  };

  return (
    <FormControl style={style}>
      <FormLabel
        color={labelColor ? labelColor : "#898989"}
        marginBottom={2}
        fontFamily="PlusJakartaSansMedium"
        fontSize={labelSize ? labelSize : "14px"}
        letterSpacing={"2px"}
        textTransform={"capitalize"}
      >
        {label}
      </FormLabel>
      <InputGroup>
        {!isMultiSelect ? (
          <Select
            value={value}
            onChange={(e) => handleChange(e)}
            placeholder={placeholder}
            bg={"white"}
            fontFamily="PlusJakartaSansMedium"
            borderRadius={8}
            focusBorderColor="transparent" // Remove focus border
            _focus={{ boxShadow: "none" }} // Remove any focus outline
            fontSize={12}
            icon={<ArrowDown />}
            iconSize="1rem"
            style={inputStyle}
            height={"48px"}
            width={"184px"}
            cursor={"pointer"}
          >
            {children}
          </Select>
        ) : (
          <ReactSelect
            isMulti
            menuPortalTarget={document.body}
            onChange={(selectedValues) => onChange(selectedValues)}
            styles={{
              container: (styles) => ({ ...styles, width: "100%" }),
              menuPortal: (styles) => ({ ...styles, zIndex: 9999 }),
            }}
            options={children?.map((child) => ({
              value: child?.props.value,
              label: child?.props.children,
            }))}
          />
        )}
      </InputGroup>
    </FormControl>
  );
};

export default CustomSelect;
